const GlitchContext = require('./glitchcontext.js')
const PartContext = require('./partcontext.js')
const GameContext = require('./gamecontext.js')
module.exports = function ContextMenu (state, emit) {
   if (state.selectedGlitchId) {
    return GlitchContext(state, emit)
  }
  if (state.selectedPartId) {
    return PartContext(state, emit)
  }

  return GameContext(state, emit)
}
